import { render, staticRenderFns } from "./AccessNotesTable.vue?vue&type=template&id=231e5db0&"
import script from "./AccessNotesTable.vue?vue&type=script&lang=js&"
export * from "./AccessNotesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports